import React from 'react'
import {connect} from 'dva'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {modelUtils} from '@/utils'

const {WizDataTable} = component_tool
const {WizContainer, ossFileUtils} = framework_tool
const {getPageData} = utils_tool

class ChangeRecordDetail extends WizContainer {
  componentName = 'changeRecordDetail'

  constructor(props) {
    super(props)
    this.state = {}
  }

  _componentDidMount() {
    this._list()
  }

  _list = (params = {}) => {
    const {record = {}} = this.props
    this.doAction({
      path: 'changeRecordDetail/pageList',
      payload: {
        key: 'pageList@' + record.id,
        apiParams: {
          positionRecordId: record.id,
          ...params
        }
      }
    })
  }

  propsAndStateOnChange = {
  }

  render() {
    let columns = [
      {
        title: 'id',
        name: 'id',
        dataIndex: 'id',
      },
      {
        title: '表名称',
        name: 'name',
        dataIndex: 'name',
        tableItem: {}
      },
      {
        title: '变更条数',
        name: 'changeCount',
        dataIndex: 'changeCount',
        tableItem: {}
      },
      {
        title: '状态',
        name: 'state',
        dataIndex: 'state',
        dict: [
          {code: 0, codeName: '失败'},
          {code: 1, codeName: '成功'},
        ],
        tableItem: {}
      },
      {
        title: '记录日志信息',
        name: 'logInfo',
        dataIndex: 'logInfo',
        tableItem: {}
      },
    ]
    let dataItems = getPageData(this.props.list.data)
    let tableProps = {
      columns,
      dataItems,
      rowKey: 'id',
      selectType: 'radio',
      isScroll: true,
      scroll: {y: 420},
      onChange: ({pageNum, pageSize}) => this._list({current: pageNum, size: pageSize}),
      onSelect: (keys, rows) => {
        let row = rows[0]
        this.setState({fileId: row.fileId})
      }
    }
    return (
      <>
        <WizDataTable {...tableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination showLessItems size='small' {...tableProps} />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {changeRecordDetail} = state
  const list = modelUtils.getModelEntity(changeRecordDetail, 'pageList@' + ownProps.record.id)
  return {
    list,
  }
}

const options = {withRef: true}

export default connect(mapStateToProps, null, null, options)(ChangeRecordDetail)


